export default __webpack_public_path__ + "locales/lo-LA/Translations.json?hash=45be295416b953e901b347e7b633ba50";